<template>
  <div class="faqWebContainer alignfull">
    <div class="container-fluid container-lg">
      <div class="d-flex justify-content-between align-items-center">
        <!--Första länken existerar bara för att skapa en filler-div med samma bredd som länken efter <H1></H1>-->
        <a v-if="site == 'geab' && type != 'foretag'" href="https://www.gavleenergi.se/foretag/kundservice/"
          class="link invisible d-none d-lg-block">
          Kundservice företag
          <i class="far fa-fw fa-arrow-right"></i>
        </a>
        <h1 class="text-center pt-5 flex-grow-1">Hur kan vi hjälpa dig?</h1>
        <a v-if="site == 'geab' && type != 'foretag'" href="https://www.gavleenergi.se/foretag/kundservice/"
          class="pt-3 btn btn-link d-none d-lg-block">
          Kundservice företag<i class="ms-1 far fa-fw fa-arrow-right"></i>
        </a>
      </div>
      <p class="text-center lead pb-2">Sök och få svar på din fråga eller bläddra mellan kategorierna i vår FAQ.</p>

      <template v-if="questions.length > 0">
        <div class="w-100 d-flex justify-content-center">
          <a v-if="site == 'geab' && type != 'foretag'" href="https://www.gavleenergi.se/foretag/kundservice/"
            class=" btn btn-link d-lg-none">
            Kundservice företag<i class="ms-1 far fa-fw fa-arrow-right"></i>
          </a>
        </div>
        <div class="my-4 mx-auto" style="max-width: 500px">
          <input type="search" class="form-control border-0 p-3" placeholder="Skriv in och sök på din fråga här"
            aria-label="Sök" v-model="searchQuery" />

          <div v-if="searchQuery.length > 2" class="position-absolute bg-white searchResults shadow p-1 rounded"
            style="z-index: 9; max-width: 500px" id="searchAccordion">
            <FaqAccordion :voteForm="voteForm" :questions="searchResults.slice(0, 10)" :site="site"></FaqAccordion>

            <template v-if="searchQuery.length > 2 && searchResults.length == 0">
              <div class="p-3 d-flex flex-row align-items-center bg-white">
                <i class="me-3 fa-2x far fa-exclamation-triangle"></i>
                <div>Hittade tyvärr inget som matchade det du sökte på.</div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <div class="d-flex w-100 justify-content-center" v-else>
        <img width="100" src="https://cdn.gavleenergi.se/img/spinner.svg">
      </div>
       <template v-if="selectedMain.id != 0">
        <div @click="reset()" style="cursor: pointer" class=" ">
          <div class="faqWebNavigation d-flex justify-content-center align-items-center mb-2 mb-lg-4">
            <span class="rounded-circle d-inline-block me-2">
              <i class="far fa-lg fa-fw fa-arrow-left"></i>
            </span>
            <span v-html="selectedMain.name" class="h2 m-0"></span>
          </div>
        </div>
      </template>

      <CategoryRow v-if="selectedMain.id == 0" :categories="mainCategories" :selectCat="selectMain"
        :selected="selectedMain" />

      <CategoryRow v-if="selectedMain.id != 0" :categories="currentSubCats" :selectCat="selectSubCat"
        :selected="selectedSubCat" />
    </div>
  </div>

  <div class="faqWebAccordion alignfull pt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-xl-8">
          <h2 class="text-center mb-4 text-body">Vanliga frågor <span v-html="selectedMain.name"></span></h2>
          <FaqAccordion :voteForm="voteForm" :questions="currentQuestions" :currentQ="currentQ" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import CategoryRow from "./CategoryRow.vue";
import FaqAccordion from "./FaqAccordion.vue";

export default {
  components: { CategoryRow, FaqAccordion },
  data() {
    let mainCategories = [];
    let subCategories = [];
    let searchResults = [];
    let currentQuestions = [];
    let questions = [];
    let selectedMain = { id: 0 };
    let selectedSubCat = { id: 0 };
    let currentSubCats = [];
    let currentQ;
    let searchQuery = ref("");
    let queryString = window.location.search;

    return {
      mainCategories,
      subCategories,
      questions,
      selectedMain,
      selectedSubCat,
      currentSubCats,
      currentQuestions,
      currentQ,
      searchQuery,
      searchResults,
      queryString,
      landingFaqs: [],
    };
  },
  props: { theme: { type: Object }, site: { type: String }, type: { type: String } },
  methods: {
    fetchData() {
      //let url1 = "https://cockpit.gavleenergi.se/wp-json/wp/v2/categories?per_page=100&filter[meta_key]=site&filter[meta_value]=" + this.site + "&filter[meta_compare]=LIKE";
      //let url2 = "https://cockpit.gavleenergi.se/wp-json/wp/v2/faq?per_page=500&filter[meta_key]=site&filter[meta_value]=" + this.site + "&filter[meta_compare]=LIKE";

      let url1 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" + this.site + "&type=cat";
      this.type != null ? url1 += `&t=${this.type}` : '';
      let url2 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/?site=" + this.site + "&type=que&";
      this.type != null ? url2 += `&t=${this.type}` : '';


      Promise.all([fetch(url1).then((res) => res.json()), fetch(url2).then((res) => res.json())]).then((json) => {
        // Filtrera kategorier baserat på typ och logga resultatet    
        const filteredCategories = this.type
          ? json[0].filter((cat) => cat.acf && cat.acf.type && cat.acf.type.includes(this.type))
          : json[0]; // Om this.type är null, returnera alla kategorier

        console.log("Filtered Categories:", filteredCategories);

        // Sortera i mainCategories och subCategories
        filteredCategories.map((cat) => {
          if (cat.parent === 0) {
            this.mainCategories.push(cat);
          } else {
            this.subCategories.push(cat);
          }
        });

        // Kontrollera resultatet
        console.log("Main Categories:", this.mainCategories);
        console.log("Sub Categories:", this.subCategories);

        this.questions = json[1];
        console.log(json[1]);
        this.questions.map((q) => {
          if (q.acf.prioritized == true) {
            this.landingFaqs.push(q);
          }
        });
        console.log(json[0]);

        const urlParams = new URLSearchParams(this.queryString);

        if (urlParams.get("q")) {
          let urlQ = urlParams.get("q");
          let q = this.questions.find(({ id }) => id == urlQ);
          this.setCurrentQ(q);
        } else if (urlParams.get("c")) {
          let urlC = urlParams.get("c");
          let c = this.subCategories.find(({ id }) => id == urlC);
          console.log(c);
          let mc = this.mainCategories.find(({ id }) => id == c.parent);
          console.log(mc);
          this.selectMain(mc);
          this.selectSubCat(c);
        } else {
          this.currentQuestions = this.landingFaqs;
        }
      });
    },

    selectMain(cat) {
      this.currentSubCats = [];
      if (this.subCategories.find(({ parent }) => parent == cat.id)) {
        this.selectSubCat(this.subCategories.find(({ parent }) => parent == cat.id));
        //this.selectSubCat(this.subCategories[4])
      }
      this.subCategories.map((subCat) => {
        if (subCat.parent == cat.id) {
          this.currentSubCats.push(subCat);
        }
      });

      this.selectedMain = cat;
    },

    selectSubCat(cat) {
      this.currentQuestions = [];
      this.selectedSubCat = cat;

      this.questions.map((q) => {
        if (q.categories.find((id) => id == cat.id)) {
          this.currentQuestions.push(q);
        }
      });
    },

    setCurrentQ(q) {
      this.currentQ = q;
      this.currentQuestions = [];

      let subCat = this.subCategories.find(({ id }) => id == q.categories[0]);
      //this.selectedMain = this.mainCategories.find(({ id }) => id == subCat.parent)
      //this.selectedSubCat = subCat

      this.selectMain(this.mainCategories.find(({ id }) => id == subCat.parent));
      this.selectedSubCat = subCat;
      this.questions.map((q) => {
        if (q.categories[0] == subCat.id) {
          this.currentQuestions.push(q);
        }
      });

      if (this.searchResults.length > 1) {
        this.searchResults = [];
        this.searchQuery = "";
      }

      window.setTimeout(() => {
        document.getElementById(q.id).scrollIntoView({ behavior: "smooth" });
      }, 200);
    },

    reset() {
      this.selectedMain = { id: 0 };
      this.selectedSubCat = { id: 0 };
      this.currentQuestions = this.landingFaqs;
      this.currentQ = {};
    },

    categoryExists(q) {
      q.categories.map((cat) => {
        this.subCategories.map((subCat) => {
          if (cat == subCat.id) {
            this.mainCategories.map((mainCat) => {
              if (mainCat.id == subCat.parent) {
                this.setCurrentQ(q);
              }
            });
          }
        });
      });
    },

    voteForm(id, opinion) {
      var formData = new FormData();
      formData.append("id", id);
      formData.append("opinion", opinion);

      fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/faq/vote/", {
        method: "POST",
        body: formData,
      });

      document.getElementById("vote-" + id).classList.add("d-none");
      document.getElementById("voted-" + id).classList.remove("d-none");
    },

    searchFilter(row) {
      //gör array av sökord
      let searchWordArray = this.searchQuery.split(" ");

      function filterWords(word) {
        let temp = false;

        if (row.title != null && row.title.rendered.toString().toLowerCase().includes(word.toLowerCase())) {
          temp = true;
        }

        Object.values(row).map((prop) => {
          if (prop != null && prop.toString().toLowerCase().includes(word.toLowerCase())) {
            temp = true;
          }
        });
        return temp;
      }

      //kolla om ett ord finns någonstans i object-value. Om det sker minst en gång ändras temp till true.
      return searchWordArray.every(filterWords);
    },
  },

  watch: {
    searchQuery() {
      this.searchResults = [];

      if (this.searchQuery.length > 0) {
        this.searchResults = this.questions.filter(this.searchFilter);
      }
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped></style>
